import { RootContainer } from '../../../root_container';
import { CouponModalAction } from '../../../actions/coupon/coupon_modal_action';
import { CouponModalJsEnv } from '../../../models/coupon/coupon_modal_js_env';
import { CouponModalContentsBody } from './coupon_modal_body';

export class CouponModalContainer extends RootContainer<CouponModalJsEnv> {
  constructor() {
    super();

    this.mount(CouponModalContentsBody, 'js-coupon-modal-contents');

    CouponModalAction.DISPLAY_COUPON_MODAL_EVENT.on((model) => {
      this.update(model);
    });
  }
}
